import GET_ARTICLES from "../plugins/getArticles"

const [ w, d, l, content ] = [ window, document, location, 'development' ]

const init = () => {
  if( w.load['loadHtml'] ){
    w.load['loadHtml'].then( () => {
      // ナビゲーションカレント
      $('.nav-development[data-plugin="currentMenu"]').currentMenu({mode:0})

      // 製品情報読み込み
      let makeItem = item => $(`
        <a href="${item.href}" class="works-item">
          <figure class="works-item__img">
            <div class="works-item__img-cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="300" loading="lazy"></div>
          </figure>
          <div class="works-item__body">
            <span class="cate">${item.category.name}</span>
            <h4 class="subject">
              ${item.title}${item.is_new ? '<span class="new">NEW</span>': ''}
            </h4>
          </div>
        </a>
      `)[0]
      GET_ARTICLES('.development-strength__list[data-plugin="getArticles"]',{ makeItem })
    })
  }
}

export default function DEVELOPMENT() {
  $(() => init() )
}